<template>
  <div
    v-if="def && visible"
    :class="def.expandable || def.componentPath ? 'pa-0' : 'py-5'"
  >
    <app-expandable-panel 
      v-if="def.expandable" 
      :def="def" 
    >
      <template #expandablePanelHeader>
        {{ $t(def) }}
      </template>
      <template #expandablePanelContent>
        <AbrFormPanelWrapper
          :model="Model"
          :def="def"
          :modal="modal"
        />
      </template>
    </app-expandable-panel>
    <div v-else>
      <AbrFormPanelWrapper
        :model="Model"
        :def="def"
        :modal="modal"
      />
    </div>
  </div>
</template>

<script>
import AbrFormPanelWrapper from "./AbrFormPanelWrapper";
import AppExpandablePanel from "@/components/library/expandablePanel/AppExpandablePanel";
export default {
  name: "AbrFormPanel",
  components: {
    AbrFormPanelWrapper,
    AppExpandablePanel
  },
  props: ["def", "model","modal"],
  data: vm => ({
    Model: vm.model,
    open: [0],
    visible: true
  }),
  created() {
    this.checkExceptionData()
    this.$watch("model", async () => {
      this.visible = await this.$checkVisibility(this.def);
    }, { deep: true });
  },
  methods:{
    checkExceptionData(){
      if(typeof this.model !== 'object'){
        this.Model = JSON.parse(this.model)
      }
    }
  }


};
</script>
<style>
.Panel-text {
  margin: 0!important;
  font-family: IRANYekan;
  font-size: 14px !important;
  letter-spacing: normal;
  text-align: right;
}
</style>
